import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

function Hsn() {
  const initialForm = {
    store_id: "",
    store_hsn: "",
    store_short_name: "",
    store_type: "Goods",
    store_sgst: "",
    store_cgst: "",
    store_igst: "",
    store_lock: "Yes",
    alertMsg: "",
    alertMsgTyp: "",
    isAlert: false,
  };

  const [isAdmin , setIsAdmin] = useState('')

   const [searchTerm, setSearchTerm] = useState("");

  const [formData, setFormData] = useState(initialForm);
  const [ldata, setLdata] = useState(null);
  const [records, setRecords] = useState([]); // 🔥 records list

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updatedData = {
        ...prev,
        [name]: value,
      };

      // SGST + CGST → IGST
      if (name === "store_sgst" || name === "store_cgst") {
        const sgst = parseFloat(
          name === "store_sgst" ? value : prev.store_sgst
        ) || 0;

        const cgst = parseFloat(
          name === "store_cgst" ? value : prev.store_cgst
        ) || 0;

        updatedData.store_igst = sgst + cgst;
      }

      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("store_id", formData.store_id);
    fd.append("store_hsn", formData.store_hsn);
    fd.append("store_short_name", formData.store_short_name);
    fd.append("store_type", formData.store_type);
    fd.append("store_sgst", formData.store_sgst);
    fd.append("store_cgst", formData.store_cgst);
    fd.append("store_igst", formData.store_igst);
    fd.append("store_lock", formData.store_lock);
    fd.append("store_user", ldata.user_id);

    try {
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.CreateStoreHns,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        setFormData({
          ...initialForm,
          isAlert: true,
          alertMsg: response.data.success,
          alertMsgTyp: response.data.type,
        });
        fetchRecords(); // 🔥 refresh table
        toast.success("Saved Successfully");
      } else {
        setFormData((prev) => ({
          ...prev,
          isAlert: true,
          alertMsg: response.data.success,
          alertMsgTyp: response.data.type,
        }));
        toast.error("Failed to Save");
      }
    } catch (error) {
      setFormData((prev) => ({
        ...prev,
        isAlert: true,
        alertMsg: "Failed",
        alertMsgTyp: "danger",
      }));
      toast.error("Failed to Save");
    }
  };

  // 🔥 Fetch all records
  const fetchRecords = async () => {
    try {
      const response = await axios.get(
        AppConst.BASE_URL + AppConst.GetAllStoreHns
      );
      console.log("res : " + JSON.stringify(response.data));
      if (response.data.status) {
        setRecords(response.data.list);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🔥 Edit record
  const handleEdit = (rec) => {
    setFormData({
      ...formData,
      store_id: rec.id,
      store_hsn: rec.store_hsn,
      store_short_name: rec.store_short_name,
      store_type: rec.store_type,
      store_sgst: rec.store_sgst,
      store_cgst: rec.store_cgst,
      store_igst: rec.store_igst,
      store_lock: rec.store_lock,
    });
  };

  // 🔥 Delete record
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this record?")) return;
    try {
      const fd = new FormData();
      fd.append("id", id);
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.DeleteStoreHns,
        fd
      );
      if (response.data.status) {
        toast.success("Deleted Successfully");
        fetchRecords();
      } else {
        toast.error("Failed to Delete");
      }
    } catch (err) {
      toast.error("Error deleting record");
    }
  };

  // 🔥 Initial load
  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
      const userData = JSON.parse(sessionStorage.getItem("ldata"));
  const roleId = userData?.role_id;
    if (roleId === 1 || roleId === "1") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
    }
    fetchRecords();
  }, []);

    const filteredRecords = records.filter((rec) =>
    [rec.store_hsn, rec.store_short_name, rec.store_type]
      .some((field) =>
        field?.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
  );
    return (
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                {/* <div class="col-xxl-2"></div> */}
                    <div class="col-xxl-12">
                        <div class="card">
                            

                            <div class="card-body">
                                <h5>Hsn</h5>
                                <br/>
                                <div class="live-preview">
                                    <form onSubmit={handleSubmit}>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="firstNameinput" class="form-label">HSN/SAC</label>
                                                    <input type="text" class="form-control" placeholder="Enter HSN/SAC" 
                                                    name="store_hsn" onChange={handleChange} value={formData.store_hsn}/>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="mb-3">
                                                    <label for="lastNameinput" class="form-label">Short Name</label>
                                                    <input type="text" class="form-control" placeholder="Enter Short Name"
                                                    name="store_short_name" onChange={handleChange} value={formData.store_short_name}/>
                                                </div>
                                            </div>
                                           
                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="compnayNameinput" class="form-label">Type</label>
                                                    <select class="form-control" data-trigger="" 
                                                    name="store_short_type" onChange={handleChange} value={formData.store_type}>
                                                        <option value="Active">Goods</option>
                                                        <option value="Deactive">Other</option>

                                                    </select>
                                                </div>
                                            </div>
                                            
                                           <div class="col-md-4">
  <div class="mb-3">
    <label class="form-label">SGST(%)</label>
    <input 
      type="tel" 
      class="form-control" 
      placeholder="SGST"
      name="store_sgst" 
      onChange={handleChange} 
      value={formData.store_sgst} 
    />
  </div>
</div>

<div class="col-md-4">
  <div class="mb-3">
    <label class="form-label">CGST(%)</label>
    <input 
      type="tel" 
      class="form-control" 
      placeholder="CGST"
      name="store_cgst" 
      onChange={handleChange} 
      value={formData.store_cgst} 
    />
  </div>
</div>

<div class="col-md-4">
  <div class="mb-3">
    <label class="form-label">IGST(%)</label>
    <input 
      type="tel" 
      class="form-control" 
      placeholder="IGST"
      name="store_igst" 
      value={formData.store_igst} 
      readOnly   // read only rakhenge taaki manually na change ho
    />
  </div>
</div>

                                            <div class="col-md-4">
                                                <div class="mb-3">
                                                    <label for="compnayNameinput" class="form-label">Lock</label>
                                                    <select class="form-control" data-trigger="" 
                                                    name="store_lock" onChange={handleChange} value={formData.store_lock}>
                                                        <option value="Active">Yes</option>
                                                        <option value="Deactive">No</option>

                                                    </select>
                                                </div>
                                            </div>
                                            
                                       
                                            <div class="col-lg-12">
                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary">Save</button>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        
                                    </form>
                                </div>
                                
                            </div>
                        </div>
                         <div class="card mt-4">
              <div class="card-body">
                  <div className="flex justify-content-between p-2" style={{display: "flex", alignItems: "center"}}>
                 <h5>HSN Records</h5>
                 <div className="mb-2 mt-2 col-4">
                   <input
        type="text"
        className="form-control mb-3 col"
        placeholder="Search by HSN, Short Name or Type..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

                 </div>

                  </div>

      {/* 🔍 Search bar */}
     
      <table className="table table-bordered mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>HSN</th>
            <th>Short Name</th>
            <th>Type</th>
            <th>SGST</th>
            <th>CGST</th>
            <th>IGST</th>
            <th>Lock</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredRecords.length > 0 ? (
            filteredRecords.map((rec) => (
              <tr key={rec.id}>
                <td>{rec.id}</td>
                <td>{rec.store_hsn}</td>
                <td>{rec.store_short_name}</td>
                <td>{rec.store_type}</td>
                <td>{rec.store_sgst}</td>
                <td>{rec.store_cgst}</td>
                <td>{rec.store_igst}</td>
                <td>{rec.store_lock}</td>
                <td>
                  <button
                    className="btn btn-sm btn-info me-2"
                    onClick={() => handleEdit(rec)}
                         disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDelete(rec.id)}
                         disabled={!isAdmin} // ❌ normal user ke liye disable
                                                         style={{ opacity: !isAdmin ? 0.5 : 1, pointerEvents: !isAdmin ? "none" : "auto" }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center">
                No Records Found
              </td>
            </tr>
          )}
        </tbody>
      </table>
              </div>
            </div>
                    </div> 
                    {/* <div class="col-xxl-2"></div> */}
                </div>

            </div>
        </div>
    );
}

export default Hsn;
